import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { PhoneCall, CheckCircle2, XCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABEL = { sent: "Aguardando", accepted: "Aceita", rejected: "Recusada", completed: "Concluída", canceled: "Cancelada" };

export default function SentCallsSection() {
  const [items, setItems] = useState([]);
  const load = () => axios.get(`${API}/freelancers/invites/sent`).then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); const iv = setInterval(load, 12000); return () => clearInterval(iv); }, []);

  const complete = async (inv) => {
    if (!window.confirm(`Marcar a chamada como concluída e liberar R$ ${Number(inv.call_price).toFixed(2)} para ${inv.freelancer_name}?`)) return;
    try { await axios.post(`${API}/freelancers/invites/${inv.invite_id}/complete`); toast.success("Chamada concluída — valor liberado"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };
  const cancel = async (inv) => {
    if (!window.confirm("Cancelar esta chamada? O valor volta para sua carteira.")) return;
    try { await axios.post(`${API}/freelancers/invites/${inv.invite_id}/cancel`); toast.success("Chamada cancelada e valor devolvido"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  if (items.length === 0) return null;
  return (
    <Card className="p-4" data-testid="sent-calls-section">
      <h3 className="font-bold flex items-center gap-2 mb-3"><PhoneCall className="w-4 h-4 text-primary" /> Chamadas enviadas ({items.length})</h3>
      <div className="space-y-2">
        {items.map(inv => (
          <div key={inv.invite_id} className="flex items-center gap-3 p-3 rounded-lg border" data-testid={`sent-call-${inv.invite_id}`}>
            <Avatar className="w-9 h-9"><AvatarImage src={inv.freelancer_picture} /><AvatarFallback>{inv.freelancer_name?.[0]}</AvatarFallback></Avatar>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">{inv.title} <span className="text-muted-foreground font-normal">· {inv.freelancer_name}</span></div>
              <div className="text-xs text-muted-foreground">
                {Number(inv.call_price) > 0 ? `R$ ${Number(inv.call_price).toFixed(2)} · escrow ${inv.escrow_status === "locked" ? "bloqueado" : inv.escrow_status === "released" ? "liberado" : inv.escrow_status === "refunded" ? "devolvido" : "-"}` : "Sem valor de chamada"}
              </div>
            </div>
            <Badge variant={inv.status === "completed" ? "default" : inv.status === "accepted" ? "secondary" : "outline"} data-testid={`sent-call-status-${inv.invite_id}`}>{LABEL[inv.status] || inv.status}</Badge>
            {inv.status === "accepted" && <Button size="sm" className="rounded-full gap-1" data-testid={`sent-call-complete-${inv.invite_id}`} onClick={() => complete(inv)}><CheckCircle2 className="w-3.5 h-3.5" /> Concluir</Button>}
            {inv.status === "sent" && <Button size="sm" variant="ghost" className="rounded-full gap-1 text-red-600" data-testid={`sent-call-cancel-${inv.invite_id}`} onClick={() => cancel(inv)}><XCircle className="w-3.5 h-3.5" /> Cancelar</Button>}
          </div>
        ))}
      </div>
    </Card>
  );
}
